import { BildungsloginApiFactory, GroupRole } from '../../api/v2';
import { MNSproCloudApi } from '../..';

const generateApi = (authToken: string) => {
  const config = MNSproCloudApi.V2.createConfiguration(authToken);
  return BildungsloginApiFactory(config);
};

export class BildungsloginCirclesOfLearningService {
  static async getCirclesOfLearning(
    authToken: string,
    organizationId: string,
  ): Promise<GroupRole[]> {
    const api = generateApi(authToken);
    const result = await api.getCirclesOfLearning(organizationId);

    return result.data.circlesOfLearning || [];
  }

  static async updateCirclesOfLearning(
    authToken: string,
    organizationId: string,
    groupRole: GroupRole[],
  ): Promise<GroupRole[]> {
    const api = generateApi(authToken);
    const result = await api.updateCirclesOfLearning(organizationId, groupRole);

    return result.data.circlesOfLearning || [];
  }
}
